import { createApiSlice } from "@common";
import { CRUD_EMPLOYMENT_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addEmploymentType",
    method: "post",
    url: CRUD_EMPLOYMENT_TYPE,
    stateKey: "message"
  },
  {
    name: "getEmploymentType",
    method: "get",
    url: CRUD_EMPLOYMENT_TYPE,
    stateKey: "data"
  },
  {
    name: "updateEmploymentType",
    method: "put",
    url: CRUD_EMPLOYMENT_TYPE,
    stateKey: "message"
  },
  {
    name: "deleteEmploymentType",
    method: "delete",
    url: CRUD_EMPLOYMENT_TYPE,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData:
      (state, action) => {
        state.additionalData = action.payload;
      },
  },
  extraReducers: {},
};

const { slice, thunks, actions } =
  createApiSlice("EmploymentType", apiConfig, customReducers);
const EmploymentTypeSlice = slice;

export default EmploymentTypeSlice.reducer;

export const {
  addEmploymentType,
  getEmploymentType,
  updateEmploymentType,
  deleteEmploymentType
} = thunks;
export const {
  rowSelect
} = actions;
